import React, {useState, useEffect} from 'react';
import MessageList from '../components/MessageList';
import ChatBar from '../components/ChatBar';
import TopBar from '../components/TopBar';
import ImageModal from '../components/ImageModal';
import '../App.css'; 

import {io} from 'socket.io-client';

const socket = io();

function MainPage(props) {
    const [messages, setMessages] = useState([]);
    const [isDisabled, setIsDisabled] = useState(false);
    const [showChatModal, setShowChatModal] = useState(false);
    const [optionList, setOptionList] = useState([]);
    const [imageUrl, setImageUrl] = useState("");

    const init = () => {
        setMessages([]);
        setIsDisabled(false);
        setShowChatModal(false);
        setOptionList([]);
        setImageUrl("");
    }

    useEffect(() => {
        const appHeight = () => {
            document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
        }
        window.addEventListener('resize', appHeight);
        appHeight()
        socket.on("connect", () => {
            console.log(socket.connected);
            init();
        });
        socket.on("message", (message) => {
            // console.log(data);
            setIsDisabled(message.isDisabled);
            if (message.showOption) {
                setTimeout(() => {
                    setOptionList(message.data)
                }, 1000);
            }
            setMessages(messages => ([...messages, {speaker: 0, ...message}]))
        })
        return () => {
            socket.close();
        }
    }, []);


    const sendMessage = (message) => {
        socket.emit("message", socket.id, message);
        setMessages(messages => ([...messages, {speaker: 1, ...message}]))
        setOptionList([]);
    }

    return (
        <div className="main-page" onClick={(e)=>{setShowChatModal(false)}}>
            {imageUrl?<ImageModal imageUrl={imageUrl} setImageUrl={setImageUrl}></ImageModal>:null}
            <div className="main-page__center col-12">
                <TopBar></TopBar>
                <MessageList messages={messages}
                            sendMessage={sendMessage}
                            isDisabled={isDisabled}
                            optionList={optionList}
                            setImageUrl={setImageUrl}></MessageList>
                <ChatBar sendMessage={sendMessage}
                        isDisabled={isDisabled}
                        showChatModal={showChatModal}
                        setShowChatModal={setShowChatModal}></ChatBar>
            </div>
        </div>
    )
}


export default MainPage;
